/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a GitHub-flavored Markdown table from a simple grid. Set per-column alignment and copy the formatted, padded result.`)
};

const es_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construye una tabla Markdown compatible con GitHub a partir de una cuadrícula simple. Configura la alineación por columna y copia el resultado formateado y ajustado.`)
};

const de_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie aus einem einfachen Raster eine GitHub Flavored Markdown-Tabelle. Legen Sie die Ausrichtung pro Spalte fest und kopieren Sie das formatierte, ausgerichtete Ergebnis.`)
};

const nl_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bouw een GitHub Flavored Markdown-tabel uit een eenvoudig raster. Stel per-kolom uitlijning in en kopieer het opgemaakte, aangevulde resultaat.`)
};

const fr_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un tableau Markdown GitHub Flavored à partir d'une grille simple. Définissez l'alignement par colonne et copiez le résultat formaté et complété.`)
};

const it_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una tabella Markdown con flavour GitHub da una griglia semplice. Imposta l'allineamento per colonna e copia il risultato formattato e riempito.`)
};

const pt_br2_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie uma tabela Markdown compatível com GitHub a partir de uma grade simples. Defina o alinhamento por coluna e copie o resultado formatado e preenchido.`)
};

const pt_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construa uma tabela Markdown compatível com GitHub a partir de uma grelha simples. Defina o alinhamento por coluna e copie o resultado formatado e preenchido.`)
};

const ja_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シンプルなグリッドから GitHub 風 Markdown テーブルを構築します。列ごとの配置を設定し、フォーマットされたテーブルをコピーできます。`)
};

const zh_mt_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过简单的网格创建 GitHub Flavored Markdown 表格。设置每列的对齐方式，复制格式化且已对齐填充的结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_intro", locale)
	if (locale === "en") return en_mt_intro(inputs)
	if (locale === "es") return es_mt_intro(inputs)
	if (locale === "de") return de_mt_intro(inputs)
	if (locale === "nl") return nl_mt_intro(inputs)
	if (locale === "fr") return fr_mt_intro(inputs)
	if (locale === "it") return it_mt_intro(inputs)
	if (locale === "pt-BR") return pt_br2_mt_intro(inputs)
	if (locale === "pt") return pt_mt_intro(inputs)
	if (locale === "ja") return ja_mt_intro(inputs)
	return zh_mt_intro(inputs)
};